import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpClientModule } from '@angular/common/http';
import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/forkJoin';

@Injectable()

  export class WaterService {

    constructor(private _http: HttpClient) { }

    public requestData(arr_dev: any[], apiToken: string): Observable<any[]> {
    //   let arr_dev = 
    //   ["squid_0202_cl_01", "squid_0202_cl_02", "squid_0202_cl_03",
    //   "squid_0202_cl_04","squid_0203_cl_01", "squid_0203_cl_02", "squid_0203_cl_03",
    //   "squid_0203_cl_04"
    // ];
      let api_string = "https://api.cognition.world/v1/sustainability/water/external/dash";
      let arr_api =[];

      // arr_dev = ["0018b21000000103"];
      // arr_dev = [];
     //console.log(arr_dev)

      for (let a of arr_dev) {
        let response;
        let dataToSend = {
          "deveui" : a
        }
        response = this._http.post(api_string, {dataToSend},{headers:{'Authorization': apiToken}});
        ////console.log(response,"response")
        arr_api.push(response)
      }
      ////console.log("arr_api",arr_api)
      return Observable.forkJoin(arr_api);
    }
  

}



// WEBPACK FOOTER //
// ./src/app/dashboard/water/water.service.ts